import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { PublicClientApplication, AuthenticationResult, AccountInfo, InteractionRequiredAuthError, LogLevel } from '@azure/msal-browser';

@Injectable({
  providedIn: 'root'
})
export class MicrosoftAuthService {
  private msalInstance: PublicClientApplication;
  private microsoftSignInRes = new BehaviorSubject<any>('');
  microsoftSignInData = this.microsoftSignInRes.asObservable();

  private microsoftSignInResLoading = new BehaviorSubject<any>(false);
  microsoftSignInLoading = this.microsoftSignInResLoading.asObservable();

  private microsoft_client_id = '86f770b3-4fb5-4677-9718-eb616f92c60e';
  private microsoft_tenant_id = 'ad98d892-b8c8-44f8-90b9-53e9fb1e84be';

  loading: boolean = false;
  private initialized: boolean = false;

  constructor() {
    this.initializeMsal();
  }

  updateMicrosoftSignInRes(value) {
    this.microsoftSignInRes.next(value);
  }

  private async initializeMsal() {
    try {
      this.msalInstance = new PublicClientApplication({
        auth: {
          clientId: this.microsoft_client_id,
          authority: 'https://login.microsoftonline.com/common',
          redirectUri: window.location.origin,
          navigateToLoginRequestUrl: true,
          postLogoutRedirectUri: '/'
        },
        cache: {
          cacheLocation: 'sessionStorage',
          storeAuthStateInCookie: false,
        },
        system: {
          loggerOptions: {
            loggerCallback(logLevel: LogLevel, message: string) {
              console.log(message);
            },
            logLevel: LogLevel.Verbose,
            piiLoggingEnabled: false,
          },
        },
      });

      await this.msalInstance.initialize();
      this.initialized = true;
      console.log('MSAL initialized successfully');
    } catch (error) {
      console.error('Error initializing MSAL:', error);
      this.initialized = false;
    }
  }

  async microsoftSignIn() {
    try {
      if (!this.initialized) {
        await this.initializeMsal();
      }

      this.loading = true;
      this.microsoftSignInResLoading.next(this.loading);

      const authResult: AuthenticationResult = await this.msalInstance.loginPopup({
        scopes: ['user.read', 'email', 'openid'],
        prompt: 'login'
      });

      const account: AccountInfo = authResult.account;

      const user_data: any = {
        user_id_token: authResult.idToken,
        user_email: account.username,
        profile_id: account.localAccountId,
        microsoft_client_id: this.microsoft_client_id
      };

      this.microsoftSignInRes.next(user_data);
    } catch (error) {
      console.error('Error signing in with Microsoft', error);
      if (error instanceof InteractionRequiredAuthError) {
        console.log('Interaction required:', error);
      }
      this.microsoftSignInRes.next({ error: error.message || 'Failed to sign in with Microsoft' });
    } finally {
      this.loading = false;
      this.microsoftSignInResLoading.next(this.loading);
    }
  }

  async microsoftSignOut() {
    try {
      if (!this.initialized) {
        await this.initializeMsal();
      }

      await this.msalInstance.logoutPopup();
      console.log('User signed out from Microsoft');
    } catch (error) {
      console.error('Error signing out from Microsoft', error);
    }
  }
}
